import NGODashboardLayout from "layout/dashboardlayout/ngodashboardlayout.js";
import React, { useEffect, useState } from "react";
import NGOInformation from "./NGOInformation";
import AccountDetails from "./AccountDetails";
import Security from "./Security";
import styled, { css } from "styled-components";
import { useSelector } from "react-redux";

const NGOSettingsLayout = () => {
  const { ngoProfile } = useSelector((state) => state.auth);

  const settingstabs = [
    {
      title: "NGO Information",
      component: <NGOInformation ngoProfile={ngoProfile} />,
    },
    {
      title: "Account Details",
      component: <AccountDetails ngoProfile={ngoProfile} />,
    },
    {
      title: "Security",
      component: <Security />,
    },
  ];

  const getRoute = localStorage.getItem("route");
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    getRoute === "0"
      ? setActiveTab(0)
      : getRoute === "1"
      ? setActiveTab(1)
      : getRoute === "2"
      ? setActiveTab(2)
      : setActiveTab(0);
  }, [getRoute]);

  const handleClick = (index) => {
    setActiveTab(index);
    localStorage.setItem("route", index);
  };

  return (
    <NGODashboardLayout
      section="Settings"
      infoText="Manage your account all in one place"
    >
      <div className="flex gap-4 max-[815px]:flex-col">
        <div className="flex flex-shrink-0 items-start bg-white rounded-md p-4">
          <div className="flex flex-col max-[815px]:flex-row max-[560px]:flex-wrap gap-4 justify-center items-center">
            {settingstabs.map((tabs, index) => (
              <TabButton
                key={index}
                active={activeTab === index}
                onClick={() => handleClick(index)}
              >
                {tabs.title}
              </TabButton>
            ))}
          </div>
        </div>
        <div className="w-full min-h-[620px]">
          {settingstabs[activeTab].component}
        </div>
      </div>
    </NGODashboardLayout>
  );
};

export default NGOSettingsLayout;

const TabButton = styled.div`
  cursor: pointer;
  border-radius: 5px;
  font-size: 16px;
  width: 100%;
  padding: 8px;
  white-space: nowrap;

  ${({ active }) =>
    active &&
    css`
      background: #213874;
      color: #ffffff;
    `};
`;
